const PAGINATION_CONFIG = {
  ELEMENTS_PER_PAGE_SMALL: 20,
  ELEMENTS_PER_PAGE_MEDIUM_UP: 30,
};

const SEARCH_ORIGINATIONS = Object.freeze({
  SEARCH_PAGE: 'search_page',
  QUICK_SEARCH_BAR: 'exposed_search',
  QUICK_SEARCH_ICON: 'search_icon',
});

export { PAGINATION_CONFIG, SEARCH_ORIGINATIONS };
